import type { TrackPlugin, Tracker } from '../../core';

/** 退出时仅尽力发送，监听归当前实例所有，销毁时精确移除。 */
export function browserUnloadFlushPlugin(): TrackPlugin {
  let removeListener: (() => void) | undefined;
  return {
    name: 'hss-browser-unload-flush-plugin',
    init(tracker: Tracker) {
      if (typeof window === 'undefined') return;
      const target = window;
      const flush = () => {
        try {
          void tracker.flush().catch(() => undefined);
        } catch { /* 即使宿主包装了 flush，退出回调也不能影响页面跳转。 */ }
      };
      removeListener = () => target.removeEventListener('pagehide', flush);
      try {
        target.addEventListener('pagehide', flush);
      } catch {
        removeListener();
        removeListener = undefined;
      }
    },
    destroy() {
      const remove = removeListener;
      removeListener = undefined;
      remove?.();
    },
  };
}
